import List from './List'
import Detail from './Detail'

export default {
  ReportFormsAnalysis: '报表分析',
  Number: '序号',
  Area: '地区',
  UnitNameBranch: '单位名称（分支机构）',
  PleaseSelect: '请选择',
  PleaseSelectADateRange: '请选择日期范围！',
  // List翻译
  List,
  // Detail翻译
  Detail,
}